export const SHOP_STATUS = {
  todo: { label: "Da comprare", tone: "warning" },
  taken: { label: "Preso in carico", tone: "info" },
  purchased: { label: "Acquistato, da consegnare", tone: "purple" },
  received: { label: "Ricevuto", tone: "success" },
  cancelled: { label: "Annullato", tone: "neutral" },
};
export const TASK_STATUS = {
  todo: { label: "Da fare", tone: "neutral" },
  in_progress: { label: "In corso", tone: "info" },
  done: { label: "Completato", tone: "success" },
  cancelled: { label: "Annullato", tone: "neutral" },
};
export const BOOK_STATUS = {
  pending: { label: "In attesa", tone: "warning" },
  confirmed: { label: "Confermata", tone: "success" },
  rejected: { label: "Rifiutata", tone: "danger" },
  cancelled: { label: "Cancellata", tone: "neutral" },
  completed: { label: "Completata", tone: "info" },
};
export const EVENT_STATUS = {
  planned: { label: "In preparazione", tone: "warning" },
  confirmed: { label: "Confermato", tone: "success" },
  completed: { label: "Concluso", tone: "info" },
  cancelled: { label: "Annullato", tone: "neutral" },
};
export const PRIORITY = {
  low: { label: "Bassa", tone: "neutral" },
  normal: { label: "Normale", tone: "info" },
  high: { label: "Alta", tone: "warning" },
  urgent: { label: "Urgente", tone: "danger" },
};
export const MOV_TYPE = {
  in: { label: "Entrata", tone: "success" },
  out: { label: "Uscita", tone: "info" },
  return: { label: "Restituzione", tone: "success" },
  damaged: { label: "Danneggiato", tone: "danger" },
  adjust: { label: "Rettifica", tone: "warning" },
};
export const ROLES = { admin: "Amministratore", manager: "Responsabile", member: "Membro" };
export const REIMB_STATUS = {
  submitted: { label: "Inviata", tone: "warning" },
  approved: { label: "Approvata", tone: "info" },
  rejected: { label: "Rifiutata", tone: "danger" },
  paid: { label: "Rimborsata", tone: "success" },
};
export const INVOICE_STATUS = {
  issued: { label: "Emessa", tone: "info" },
  paid: { label: "Pagata", tone: "success" },
  cancelled: { label: "Annullata", tone: "neutral" },
};
export const EMAIL_STATUS = {
  sent: { label: "E-mail inviata", tone: "success" },
  failed: { label: "Invio non riuscito", tone: "danger" },
  not_configured: { label: "Non inviata: e-mail non configurata", tone: "warning" },
  pending: { label: "In invio", tone: "neutral" },
};
export const MODULE_LABELS = {
  inventory: "Inventario", movements: "Entrate e uscite", shopping: "Lista della spesa", tasks: "Compiti",
  events: "Eventi", rooms: "Sale", bookings: "Prenotazioni",
};
export const WEEKDAYS = ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato", "Domenica"];

export const fmtDate = (s) => {
  if (!s) return "";
  const [y, m, d] = s.slice(0, 10).split("-");
  return `${d}.${m}.${y}`;
};
export const fmtTime = (s) => (s ? s.slice(11, 16) : "");
export const fmtLocal = (s) => (s ? `${fmtDate(s)} ${fmtTime(s)}` : "");
export const isAllDay = (b) => b?.start?.slice(11, 16) === "00:00" && b?.end?.slice(11, 16) === "23:59";
export const dayCount = (from, to) => Math.round((new Date(`${to.slice(0, 10)}T00:00`) - new Date(`${from.slice(0, 10)}T00:00`)) / 86400000) + 1;
export const fmtBookingWhen = (b) => {
  if (!isAllDay(b)) return `${fmtDate(b.start)} · ${fmtTime(b.start)}–${fmtTime(b.end)}`;
  if (b.start.slice(0, 10) === b.end.slice(0, 10)) return `${fmtDate(b.start)} · giornata intera`;
  return `${fmtDate(b.start)} – ${fmtDate(b.end)} (${dayCount(b.start, b.end)} giorni)`;
};
export const fmtDateTime = (iso) =>
  iso
    ? new Intl.DateTimeFormat("de-CH", { timeZone: "Europe/Zurich", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }).format(new Date(iso))
    : "";
export const fmtCHF = (v) => (v == null || v === "" ? "" : new Intl.NumberFormat("de-CH", { style: "currency", currency: "CHF" }).format(v));
export const fmtQty = (v) => (v == null ? "" : Number(v).toLocaleString("de-CH", { maximumFractionDigits: 3 }));

export const todayZurich = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Zurich" }).format(new Date());

export function hexToHsl(hex) {
  const n = parseInt(hex.slice(1), 16);
  const r = ((n >> 16) & 255) / 255, g = ((n >> 8) & 255) / 255, b = (n & 255) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b), l = (max + min) / 2;
  let h = 0, s = 0;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
    h *= 60;
  }
  return `${h.toFixed(1)} ${(s * 100).toFixed(1)}% ${(l * 100).toFixed(1)}%`;
}
